import { create } from "zustand"
import { useEffect } from "react"
import { useDevice } from "./DeviceProvider"
import { shallow } from "zustand/shallow"
import { DEVICE_TYPES } from "@repo/utils/constants"
import { useRouter } from "next/router"
import { logTable } from "@repo/utils"

const useNavigationStore = create((set) => ({
	isHtmlLoaded: false,
	isWebGLLoaded: false,
	isLoaded: false,
	isTransitioning: true,
	isTransitionCompleted: false,
	components: new Map(),
	setWebGLLoaded: (loaded) => set({ isWebGLLoaded: loaded }),
	setHtmlLoaded: (loaded) => set({ isHtmlLoaded: loaded }),
	setIsLoaded: (loaded) => set({ isLoaded: loaded }),
	setIsTransitioning: (transitioning) => set({ isTransitioning: transitioning }),
	setIsTransitionCompleted: (completed) => set({ isTransitionCompleted: completed }),
	reset: () =>
		set({
			isHtmlLoaded: false,
			isWebGLLoaded: false,
			isLoaded: false,
			isTransitionCompleted: false,
			components: new Map(),
		}),
	markComponentLoading: (id) => {
		set((state) => {
			const components = new Map(state.components)
			components.set(id, false)
			const total = components.size
			const allLoaded = total > 0 && Array.from(components.values()).every(Boolean)
			return { components, isHtmlLoaded: allLoaded }
		})
	},
	markComponentLoaded: (id) => {
		set((state) => {
			const components = new Map(state.components)
			if (components.has(id)) {
				components.set(id, true)
			} else {
				components.set(id, true)
			}
			const total = components.size
			const allLoaded = total > 0 && Array.from(components.values()).every(Boolean)
			return { components, isHtmlLoaded: allLoaded }
		})
	},
}))

export default function NavigationProvider() {
	const { setIsLoaded, isHtmlLoaded, isWebGLLoaded, setHtmlLoaded, setWebGLLoaded } = useNavigationStore()
	const device = useDevice((state) => state.device)
	const router = useRouter()

	useEffect(() => {
		setHtmlLoaded(true)
		if (device === DEVICE_TYPES.DESKTOP) return
		let timeoutId
		setWebGLLoaded(false)
		timeoutId = setTimeout(() => setWebGLLoaded(true), 2000)
		return () => {
			clearTimeout(timeoutId)
		}
	}, [router.asPath, router.locale, device])

	useEffect(() => {
		// logTable({
		// 	isHtmlLoaded,
		// 	isWebGLLoaded,
		// })
		if (isHtmlLoaded && isWebGLLoaded) setIsLoaded(true)
	}, [isHtmlLoaded, isWebGLLoaded, device, setIsLoaded])

	return null
}

export function useNavigation(selector = (state) => state) {
	return useNavigationStore(selector, shallow)
}
